import React from 'react';  //React Loadable
import ReactDOM from 'react-dom';
import App from './App';
import { loadScript } from "@paypal/paypal-js";
import registerServiceWorker from './registerServiceWorker.js';
import { BrowserRouter as Router } from "react-router-dom"
loadScript({ clientId: "Aej7SuaErw-lwKsXnpdwwYNGgWF5CFDwiTD3Pr4AL9xn8fujjE17puGpU9SOWi8KXc_iLUq0BvnAbst_", currency: "HKD" });
ReactDOM.render(
    <Router >
        <App />
    </Router>, 
document.getElementById('root'));

registerServiceWorker();
